import React, { useMemo, useRef } from 'react'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js'
import { Bar } from 'react-chartjs-2'
import type { OvertimeChartItem } from '../../graphql/types/admin_dashboard'

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend)

export const OvertimeGraph = ({
  overtimeChart,
}: {
  overtimeChart: OvertimeChartItem[]
}) => {
  const chartRef = useRef(null)

  /**
   * datasets
   */
  const datasets = useMemo(
    () => [
      {
        label: 'Überstunden geleistet',
        data: overtimeChart.map((u) => u.overtime_done),
        backgroundColor: '#2E8F43',
      },
      {
        label: 'Ausbezahlt',
        data: overtimeChart.map((u) => u.overtime_payed),
        backgroundColor: '#2497D2',
      },
      {
        label: 'Abgebaut',
        data: overtimeChart.map((u) => u.overtime_taken),
        backgroundColor: '#FD5C1C',
      },
      {
        label: 'Manuell angepasst',
        data: overtimeChart.map((u) => u.overtime_adjust),
        backgroundColor: '#8B5CF6',
      },
    ],
    [overtimeChart],
  )

  const data = {
    labels: overtimeChart.map((u) => u.name),
    datasets,
  }

  const options = {
    responsive: true,
    plugins: {
      title: {
        display: true,
        text: 'Überstunden pro Mitarbeiter',
      },
      legend: {
        position: 'top' as const,
      },
    },
    scales: {
      x: {
        stacked: true,
        ticks: {
          autoSkip: false,
        }
      },
      y: {
        stacked: true,
        autoSkip: true,
        title: {
          display: true,
          text: 'Stunden / Tage',
        },
      },
    },
  }

  return (
    <div className="flex flex-col py-3 pr-3">
      <Bar ref={chartRef} options={options} data={data} height={80} />
    </div>
  )
}